import {Component, Prop} from 'vue-property-decorator';
import * as tsx from 'vue-tsx-support';

import './style.less';

interface ICodeButton {
  click?: any;
  disable?: boolean;
}

@Component
export default class CodeButton extends tsx.Component<ICodeButton> {
  
  @Prop() public click?: any;
  @Prop({default: false}) public disable?: boolean;
  
  constructor(props: any) {
    super(props)
  }
  
  render() {
    const {click = () => {}, disable} = this.$props;
    
    return (
      <div onClick={click} class={`code-container ${disable && 'disable'}`}>
        {this.$slots.default || '发送验证码'}
      </div>
    )
  }
  
}